import { ComponentChildren } from "preact";

interface ValueCardProps {
  icon: string;
  title: string;
}

export function ValueCard(props: ValueCardProps) {
  return (
    <div style="text-align: center; padding: 1.5rem; background: #f8f9fa; border-radius: 10px;">
      <div style="font-size: 2rem; margin-bottom: 0.5rem;">{props.icon}</div>
      <h4 style="margin: 0; color: var(--primary-color);">{props.title}</h4>
    </div>
  );
}

export function ValueCards(props: { children: ComponentChildren }) {
  return (
    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; margin-top: 2rem;">
      {props.children}
    </div>
  );
}